import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { selectCouponOddsChangeV2, setCouponOddsChangeV2 } from '@mwl/core-lib';
import { Checkbox } from '@/components/Checkbox/Checkbox';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
const CouponOddsChangeSwitch: FC = () => {
  const {
    t
  } = useTranslation('sport');
  const dispatch = useTypedDispatch();
  const isAcceptOddsChange = useTypedSelector(selectCouponOddsChangeV2);
  const handleChangeOddsChange = useCallback(() => {
    dispatch(setCouponOddsChangeV2(!isAcceptOddsChange));
  }, [isAcceptOddsChange, dispatch]);
  return <Checkbox checked={isAcceptOddsChange} onChange={handleChangeOddsChange} data-sentry-element="Checkbox" data-sentry-component="CouponOddsChangeSwitch" data-sentry-source-file="CouponOddsChangeSwitch.tsx">
      {t('coupon.odds_change', 'Accept odds changes')}
    </Checkbox>;
};
export { CouponOddsChangeSwitch };